
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  isUnderpaid = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({})
export default class InvalidIcon extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }

  get failedIcon() {
    return this.isAccountForeign
      ? require("@/app/ui/assets/svg/sti-reverse-scan/icon-scan-failed-my.svg")
      : require("@/app/ui/assets/svg/sti-reverse-scan/icon-scan-failed.svg");
  }
}
